import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { DOCTOR } from "@/lib/data";

export const Doctors = ({ onBook }) => (
  <section id="doctors" data-testid="doctors-section" className="bg-bone py-28 lg:py-40">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="max-w-4xl mb-16">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-clay">
            <span className="h-[1px] w-10 bg-clay" /> Physician-led care
          </p>
          <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1.02] tracking-tight text-[var(--astera-char)]">
            You'll always see a <span className="italic text-clay">real doctor</span> — never a substitute.
          </h2>
          <p className="mt-6 max-w-2xl text-[var(--astera-char)]/65 leading-relaxed">
            Most perimenopause and hormone clinics are run by nurse practitioners and support staff.
            At ASTERA, your care is led end-to-end by a double board-certified physician with two
            decades of specialist experience.
          </p>
        </Reveal>
      </div>

      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        {/* Portrait */}
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative aspect-square overflow-hidden rounded-[28px]">
              <img
                src={DOCTOR.img}
                alt={DOCTOR.name}
                className="h-full w-full object-cover object-[center_20%]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[var(--astera-char)]/40 to-transparent" />
            </div>
          </Reveal>
        </div>

        {/* Bio */}
        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <h3 className="font-serif text-4xl md:text-5xl text-[var(--astera-char)]">{DOCTOR.name}</h3>
            <p className="mt-3 text-sm uppercase tracking-[0.16em] text-clay">{DOCTOR.role}</p>
            <p className="mt-1 text-sm text-[var(--astera-char)]/55">{DOCTOR.creds}</p>

            <div className="mt-6 flex flex-wrap gap-2.5">
              {DOCTOR.badges.map((b) => (
                <span
                  key={b}
                  className="rounded-full border border-[#EAE6E1] bg-[var(--astera-sand)]/50 px-4 py-1.5 text-xs tracking-wide text-[var(--astera-char)]/80"
                >
                  {b}
                </span>
              ))}
            </div>

            <div className="mt-8 space-y-4">
              {DOCTOR.bio.map((p, i) => (
                <p key={i} className="text-[var(--astera-char)]/70 leading-relaxed">
                  {p}
                </p>
              ))}
            </div>

            <div className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-3 border-t border-[#EAE6E1] pt-8">
              {DOCTOR.expertise.map((e) => (
                <div key={e} className="flex items-start gap-3">
                  <Check size={16} strokeWidth={1.6} className="mt-1 shrink-0 text-clay" />
                  <span className="text-sm text-[var(--astera-char)]/75">{e}</span>
                </div>
              ))}
            </div>

            <p className="mt-8 text-sm italic text-[var(--astera-char)]/55">{DOCTOR.affiliation}</p>

            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={onBook}
              data-testid="doctor-book-button"
              className="mt-10 inline-flex items-center rounded-full bg-[var(--astera-char)] px-8 py-4 text-sm uppercase tracking-[0.16em] text-[var(--astera-bone)] transition-colors duration-300 hover:bg-clay"
            >
              Book with Dr. Fefelova
            </motion.button>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
